module.exports = __webpack_public_path__ + "img/title.78a773cd.svg";